/*eslint-disable*/
import api from '../'

class MotivationPointsHistoryApi {
  // GET: records
  static list(params, cancelToken = null) {
    return api.axios.get('/motivation-points-history', {params, cancelToken})
        .then(response => response.data)
  }
}

export default MotivationPointsHistoryApi;
